export const themes = {
  default: {
    thCloseButton:
      'reset-button bg-white flex items-center justify-center leading-none m-5 rtl:right-0 rtl:slideInRight rounded-tiny shadow text-gray-darker text-sm transition-colors',
    thCloseButtonStyle: { width: 28, height: 28 },
    thCloseButtonLabel: 'a11y',
  },
  lite: {
    thCloseButton:
      'reset-button bg-white cursor-pointer leading-none mt-5 mx-5 md:mx-12 p-4 rtl:right-0 rounded-full text-gray-darker text-md rtl:slideInRight',
    thCloseButtonLabel: 'a11y',
  },
};
